import { createSlice } from '@reduxjs/toolkit';

// Initial state for facilities
const initialState = {
  facilities: [],
};

// Create the facilities slice
const facilitiesSlice = createSlice({
  name: 'facilities',
  initialState,
  reducers: {
    setFacilities: (state, action) => {
      state.facilities = action.payload;
    },
  },
});

// Export actions
export const { setFacilities } = facilitiesSlice.actions;

// Export the reducer
export default facilitiesSlice.reducer;
